import { track } from '.'

export const trackSignInCtaClicked = (event, properties) => {
  track('Sign In CTA Clicked', {
    ...properties,
    ...(event?.currentTarget?.id ? { id: event.currentTarget.id } : {}),
    ...(event?.currentTarget?.dataset.testid ? { testId: event?.currentTarget?.dataset.testid } : {}),
    className: event?.currentTarget?.className,
  })
}

export default {}
